module.exports = "/_next/static/images/cancel-a3387982fddfd8ffdc1f75d980e926e3.svg";